export default "/fonts/vendor/fontsource-roboto/files/roboto-cyrillic-400-italic.woff2?7270d0dbb41cca30909b7f1b23be78de";